import * as React from "react";
import { useLocation } from "react-router-dom";

// Each value is the last path segment of the URL the corresponding tab is mounted at,
// e.g. /devices/:deviceId/sessions resolves to DeviceTab.Sessions. Keep these strings in
// sync with the route definitions so URL <-> tab matching stays lossless.
export enum DeviceTab {
  Details = "details",
  Tokens = "tokens",
  Datasets = "datasets",
  Files = "files",
  Sessions = "sessions",
  Metrics = "metrics",
}

function deriveActiveTabFromUrl(path: string | undefined) {
  switch (path) {
    case DeviceTab.Tokens:
      return DeviceTab.Tokens;
    case DeviceTab.Datasets:
      return DeviceTab.Datasets;
    case DeviceTab.Files:
      return DeviceTab.Files;
    case DeviceTab.Sessions:
      return DeviceTab.Sessions;
    case DeviceTab.Metrics:
      return DeviceTab.Metrics;
    case DeviceTab.Details:
      return DeviceTab.Details;
    default:
      // Unknown or missing trailing segment (e.g. the device root URL) falls through
      // to Datasets, which is treated as the device landing tab.
      return DeviceTab.Datasets;
  }
}

export function useActiveDeviceTab() {
  const location = useLocation();
  const path = location.pathname.split("/").pop();

  const [activeTab, setActiveTab] = React.useState(
    deriveActiveTabFromUrl(path),
  );

  React.useEffect(() => {
    setActiveTab(deriveActiveTabFromUrl(path));
  }, [path]);

  return [activeTab, setActiveTab] as const;
}
